import { DatePipe } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ConstructAPI } from 'src/app/API/constructAPI';
import { RestApiService } from 'src/app/API/restapi';
import { ALERT_TYPE, SUCCESS_MESSAGES } from 'src/app/constants';
import { MessageClipboardComponent } from 'src/app/MessageClipboard/message-clipboard/message-clipboard.component';
import { SharedService } from 'src/app/Shared/shared-service.service';
import { Account } from 'src/model/account.model';
import { SheetDetails } from 'src/model/assetSheetRequestDetails.model';
import { AssetSheetRequestService } from 'src/services/asset-sheet-request.service';
import { CompanyService } from 'src/services/company.service';

@Component({
	selector: 'app-add-withdrawal',
	templateUrl: './add-withdrawal.component.html',
	styleUrls: ['./add-withdrawal.component.scss'],
	standalone: false
})
export class AddWithdrawalComponent implements OnInit {
	private activeModal = inject(NgbActiveModal);
	private restapi = inject(RestApiService);
	private constructApi = inject(ConstructAPI);
	protected sharedService = inject(SharedService);
	protected selectedAccountId: number;
	protected selectedAccountBalance: number;
	protected sheetRequestService = inject(AssetSheetRequestService);
	protected companyService = inject(CompanyService);
	protected datepipe = inject(DatePipe);

	protected companyBankAccountList: Account[] = [];
	protected cashAccountList: Account[] = [];
	protected loggedInCompanyId: number;
	protected loggedInCompanyCode: string;
	protected loggedInUser: string;
	protected uuid: string;

	//2-WAY BINDING INFO
	protected withdrawalDate: Date;
	protected amount = 0;
	protected disabledSubmit = false;

	@Output() passEntry = new EventEmitter<any>();
	@Input() withdrawStampOffice = false;
	@Input() withdrawServiceCharge = false;
	@Input() withdrawHandling = false;
	@Input() withdrawStampHQ = false;

	@Input() availableWithdrawalAmount = 0;

	ngOnInit(): void {
		this.withdrawalDate = new Date();

		this.loggedInCompanyId = Number(sessionStorage.getItem('companyId'));
		this.loggedInCompanyCode = sessionStorage.getItem('companyName');
		this.loggedInUser = sessionStorage.getItem('username');

		this.getAllAccountsOfCompany(this.loggedInCompanyId);
	}

	private getAllAccountsOfCompany(companyId: number) {
		const xhttp = this.restapi.getRequest(this.constructApi.getAccountsOfCompany(companyId));
		xhttp.onreadystatechange = () => {
			if (xhttp.readyState == 4 && xhttp.status == 200) {
				const jsonArray = JSON.parse(xhttp.responseText);

				jsonArray.forEach(json => {
					const amount = json.balance == undefined ? 0 : json.balance;
					const account = new Account(json.id, json.number, json.name, json.holderName, amount, json.companyId, json.username);

					if (account.Username != undefined) this.cashAccountList.push(account);
					else {
						this.companyBankAccountList.push(account);
					}
				});
			}
		};
	}

	setSelectedAccount(accountId: number) {
		if (accountId === this.selectedAccountId) return true;
		else return false;
	}

	setWithdrawalTitle() {
		if (this.withdrawServiceCharge == true) return 'Service Charge Withdrawal';
		else if (this.withdrawStampOffice == true) return 'Stamp Office Withdrawal';
		else if (this.withdrawStampHQ == true) return 'Stamp HQ Withdrawal';
		else return 'Handling Withdrawal';
	}

	isFieldNull() {
		const paymentNull = this.amount == undefined || this.amount == 0;
		const selectedAccountIdNull = this.withdrawStampHQ == false ? this.selectedAccountId == undefined : false;
		const paymentValid = isNaN(+this.amount);

		return paymentNull || selectedAccountIdNull || paymentValid;
	}

	addStampOfficeWithdrawal() {
		this.disabledSubmit = true;
		const isoTaskDate = new Date(Number(this.withdrawalDate)).toISOString();

		const data = {
			amount: this.amount,
			accountId: Number(this.selectedAccountId),
			date: isoTaskDate,
			remark: 'Stamp Office Withdrawal'
		};

		const xhr = this.restapi.postRequest(this.constructApi.getWithdrawStampOffice(), data);
		xhr.onreadystatechange = () => {
			if (xhr.readyState == 4) {
				this.disabledSubmit = false;
				if (xhr.status == 200) {
					const account = new Account(this.selectedAccountId, null, null, null, null, null, null, -this.amount);
					this.passEntry.emit(true);
					this.reset();
					this.sharedService.openAlert('Successfully withdraw stamp!', ALERT_TYPE.SUCCESS);
				} else this.sharedService.openErrorMessage(xhr);
			}
		};
	}

	//for stamp hq withdrawal need to do 2 steps:
	//1. OUT from STAMP HQ (contra mode - will OUT STAMP & ADD APPLY CASH using contra account)
	//2. Add Apply cash request to inform finance - the bank will put under STAMP HQ (hardcoded) to let finance change themselves in sheet
	asyncaddStampHQWithdrawal() {
		this.disabledSubmit = true;
		const isoTaskDate = new Date(Number(this.withdrawalDate)).toISOString();

		const data = {
			amount: this.amount,
			date: isoTaskDate,
			remark: 'Stamp HQ (30%) Withdrawal'
		};

		const xhr = this.restapi.postRequest(this.constructApi.getWithdrawStampHQContra(), data);
		xhr.onreadystatechange = async () => {
			if (xhr.readyState == 4) {
				this.disabledSubmit = false;
				if (xhr.status == 200) {
					await this.sendRequest();
					// this.passEntry.emit(true);
					this.reset();
				} else this.sharedService.openErrorMessage(xhr);
			}
		};
	}

	async buildRequestList() {
		var sheetRequestList = [];
		const uuidV4 = window.crypto.randomUUID();
		this.uuid = uuidV4.split('-')[0] + '-' + uuidV4.split('-')[1];

		const now = new Date();
		const timestamp = this.datepipe.transform(now, 'yyyy-MM-dd HH:mm:ss', '+0800');

		let acctDetails = 'CONTRA ACCT';
		let cashInOfficeDetails = '';

		let mbbMaster = this.amount;
		let sd = new SheetDetails();
		sd.Type = 'STAMP-HQ'; //hard coded
		sd.BankName = 'STAMP HQ@440-0003A'; //hard coded
		sd.FormJCompany = '';
		sd.MbbMaster = mbbMaster;
		sd.OtherBankMaster = '';

		var sqlInfo = await this.companyService.getCompanySQLInfo(this.loggedInCompanyId);
		sd.BranchName = this.loggedInCompanyCode + '@' + sqlInfo.GLCode;

		// sd.BranchName = this.loggedInCompanyCode;
		sd.AccountDetails = acctDetails;
		sd.CustomerName = '';
		sd.LineAmount = this.amount;
		sd.CashInOffice = cashInOfficeDetails;
		sd.Remark = 'STAMP HQ WITHDRAWAL CONTRA';
		sd.Ticket = '';
		sd.Timestamp = timestamp;
		sd.Uuid = this.uuid;
		sd.RequestedBy = this.loggedInUser;
		sd.Checker = 'DONE'; //HARD CODED;

		//convert all class properties into value in array
		//in this case property order is important!!
		const s = Object.values(sd);
		sheetRequestList.push(s);

		return sheetRequestList;
	}

	async sendRequest() {
		this.disabledSubmit = true;
		const result = await this.sheetRequestService.postAsstSheetRequest(await this.buildRequestList());
		if (result != undefined) {
			this.sharedService.openAlert(
				'Succcessfully did the following:\n' +
					'- Withdrawn STAMP HQ\n' +
					'- Added Apply Cash transaction\n' +
					"- Informed FINANCE about STAMP HQ WITHDRAWAL. \nFor more information please click 'G' button on navigation bar to check!",
				ALERT_TYPE.SUCCESS
			);
			this.activeModal.close();
		}
	}

	addSCWithdrawal() {
		this.disabledSubmit = true;
		const isoTaskDate = new Date(Number(this.withdrawalDate)).toISOString();

		const data = {
			amount: this.amount,
			accountId: Number(this.selectedAccountId),
			date: isoTaskDate,
			remark: 'Service Charge Withdrawal'
		};

		const xhr = this.restapi.postRequest(this.constructApi.getWithdrawServiceCharge(), data);
		xhr.onreadystatechange = () => {
			if (xhr.readyState == 4) {
				this.disabledSubmit = false;
				if (xhr.status == 200) {
					const account = new Account(this.selectedAccountId, null, null, null, null, null, null, -this.amount);
					this.passEntry.emit(true);
					this.reset();
					this.sharedService.openAlert('Successfully withdraw service charge!', ALERT_TYPE.SUCCESS);
				} else this.sharedService.openErrorMessage(xhr);
			}
		};
	}

	addHandlingWithdrawal() {
		this.disabledSubmit = true;
		const isoTaskDate = new Date(Number(this.withdrawalDate)).toISOString();

		const data = {
			amount: this.amount,
			accountId: Number(this.selectedAccountId),
			date: isoTaskDate,
			remark: 'Handling Charge Withdrawal'
		};

		const xhr = this.restapi.postRequest(this.constructApi.getWithdrawHandling(), data);
		xhr.onreadystatechange = () => {
			if (xhr.readyState == 4) {
				this.disabledSubmit = false;
				if (xhr.status == 200) {
					const account = new Account(this.selectedAccountId, null, null, null, null, null, null, -this.amount);
					this.passEntry.emit(true);
					this.reset();
					this.sharedService.openAlert('Successfully withdraw handling charge!', ALERT_TYPE.SUCCESS);
				} else this.sharedService.openErrorMessage(xhr);
			}
		};
	}

	getAccountBalance() {
		let account = this.companyBankAccountList.find(account => account.ID === Number(this.selectedAccountId));
		if (account == undefined) account = this.cashAccountList.find(account => account.ID === Number(this.selectedAccountId));

		return account.Balance;
	}

	isBalanceInsufficient(balance: number) {
		if (balance >= this.amount) return false;
		else return true;
	}

	submit() {
		if (this.isFieldNull()) {
			this.sharedService.openAlert('Please fill in all the fields', ALERT_TYPE.DANGER);
		} else if (this.sharedService.roundTo2Dec(this.amount) > this.sharedService.roundTo2Dec(this.availableWithdrawalAmount)) {
			this.sharedService.openAlert('The withdrawal amount is more than available amount!', ALERT_TYPE.DANGER);
		} else {
			if (this.withdrawStampOffice) this.addStampOfficeWithdrawal();
			else if (this.withdrawServiceCharge) this.addSCWithdrawal();
			else if (this.withdrawStampHQ) this.asyncaddStampHQWithdrawal();
			else if (this.withdrawHandling) this.addHandlingWithdrawal();
		}
	}

	reset() {
		this.activeModal.close();
	}
}
